import Accountability from '../../Icons/aboutus/accountability.svg'
import Development from '../../Icons/aboutus/development.svg'
import Innovation from '../../Icons/aboutus/innovation.svg'
import Integrity from '../../Icons/aboutus/integrity.svg'

export default function CoreValues() {
    return (
        <div className="container mx-auto my-16">
            <h3 className="md:text-[55px] md:leading-[64.57px] leading-[35.22px] text-3xl font-bold text-center md:mb-[50px]">
                <span>Our </span>
                <span className="olm-gradient-text">Core Values</span>
            </h3>
            <div className="md:space-y-0 md:space-x-4 flex md:flex-row flex-col items-center space-y-5 md:border-b border-solid border-orange-500 px-10 pt-5 md:text-start text-center">
                <div className="md:w-2/4 md:text-left text-center md:border-r border-solid border-orange-500 border-b border-solid border-orange-500 md:border-b-0 pb-10 pl-[15px] flex flex-col md:items-start items-center">
                    <Innovation />
                    <h3 className="md:text-[35px] md:leading-[41.09px] leading-[35px] text-3xl font-bold md:text-start text-center pt-3">
                        <span>Innovation</span>
                        <br />
                    </h3>

                    <br className="md:hidden" />
                    <p className="md:text-[20px] text-lg font-medium md:mr-[2.75rem] md:text-start text-center md:pt-3">
                        We consistently develop new direct mail marketing
                        strategies to provide better results for our business
                        and real estate investment customers.
                    </p>
                </div>

                <div className="md:w-2/4 md:text-left text-center border-b border-solid border-orange-500 md:border-b-0 pb-10 md:pl-[43px] flex flex-col md:items-start items-center">
                    <Development />

                    <h3 className="md:text-[35px] md:leading-[41.09px] leading-[35px] text-3xl font-bold md:text-start text-center pt-3">
                        <span>Development</span>
                        <br />
                    </h3>

                    <br className="md:hidden" />
                    <p className="md:text-[20px] text-lg font-medium md:mr-[2.75rem] md:text-start md:pt-3 text-center">
                        We are continuously growing, both personally and
                        professionally.
                    </p>
                </div>
            </div>
            <div className="md:space-y-0 md:space-x-4 flex md:flex-row flex-col items-center space-y-5 px-10">
                <div className="md:w-2/4 md:text-left text-center md:border-r border-solid border-orange-500 border-b border-solid border-orange-500 md:border-b-0 pt-[40px] pb-[25px] md:pl-[15px] flex flex-col md:items-start items-center">
                    <Accountability />

                    <h3 className="md:text-[35px] md:leading-[41.09px] leading-[35px] text-3xl font-bold md:text-start text-center pt-3">
                        <span>Accountability</span>
                        <br />
                    </h3>

                    <br className="md:hidden" />
                    <p className="md:text-[20px] text-lg font-medium md:mr-[2.75rem] md:text-start text-center md:pt-3">
                        We take ownership of our individual roles and the
                        company as a whole.
                    </p>
                </div>
                <div className="md:w-2/4 md:text-left text-center  pt-[40px] md:pl-[43px] pb-[25px] flex flex-col md:items-start items-center">
                    <Integrity />

                    <h3 className="md:text-[35px] md:leading-[41.09px] leading-[35px] text-3xl font-bold md:text-start text-center pt-3">
                        <span>Integrity</span>
                        <br />
                    </h3>

                    <br className="md:hidden" />
                    <p className="md:text-[20px] text-lg font-medium md:mr-[2.75rem] md:text-start text-center md:pt-3">
                        We hold ourselves to a high standard of professionalism.
                    </p>
                </div>
            </div>
        </div>
    )
}
